'use strict';


export function addClassDirective(classes, formClasses) {
	return function directive() {
		'ngInject';

		return {
			require: '^?form',
			link: postLink,
		}

		function postLink(scope, element, attrs, formCtrl) {
			if (attrs.hasOwnProperty('brgNoStyle')) return;
			element.addClass(classes);
			var unstyledTypes = ['checkbox', 'radio'];
			if (formCtrl && unstyledTypes.indexOf(attrs.type) == -1) {
				element.addClass(formClasses);
			}
		}
	}
}
